/**
 * Define all functions for the redux 'actions' to be used.
 */

export const toggleSidebar = () => {
	return {
		type: 'TOGGLE_SIDEBAR',
	};
};

export const updateUserData = (data) => {
	return {
		type: 'UPDATE_USER_DATA',
		userData: data,
	};
};

export const addDocumentInRedux = (document = {}) => {
	return {
		type: 'LOAD_DOCUMENT_FROM_DB',
		savedDocument: document,
	};
};

export const addPagetoActualDocument = ({ pages, pagesLength }) => {
	return {
		type: 'LOAD_PAGES_FROM_DB',
		pages,
		pagesLength,
	};
};

export const updateAdditionalData = (newData) => {
	return {
		type: 'UPDATE_ADDITIONAL_DATA',
		newData: newData,
	};
};

export const updateAdditionalTabs = (newTabs) => {
	return {
		type: 'UPDATE_ADDITIONAL_TABS',
		newTabs: newTabs.length ? newTabs : undefined,
	};
};

export const reorderThumbnails = (newOrder) => {
	return {
		type: 'REORDER_THUMBNAILS',
		newOrder,
	};
};

export const setEnvelopeSelectedDoc = ({ id }) => {
	return {
		type: 'SET_ENVELOPE_SELECTED_DOC',
		id,
	};
};

export const flushAllPages = () => {
	return {
		type: 'FLUSH_ALL_PAGES',
	};
};

export const updateExtractedFields = (newValue) => {
	return {
		type: 'UPDATE_EXTRACTED_FIELDS',
		newValue: newValue,
	};
};

export const updateWorksteps = (newValue) => {
	return {
		type: 'UPDATE_WORKSTEPS',
		newValue: newValue,
	};
};

export const docListStatus = (newValue) => {
	return {
		type: 'UPDATE_DOC_LIST_STATUS',
		newValue,
	};
};

export const removePageFromDoc = (page) => {
	return {
		type: 'REMOVE_PAGE_FROM_DOCUMENT',
		page,
	};
};

export const updateDocTypeList = (newList) => {
	return {
		type: 'UPDATE_TYPES_LIST',
		newList,
	};
};

export const updateReference = (newRef) => {
	return {
		type: 'UPDATE_REF',
		newRef,
	};
};

export const updateRecognisedRef = (newRecRef) => {
	return {
		type: 'UPDATE_REC_REF',
		newRecRef
	}
}

export const addLoadingFlag = (page) => {
	return {
		type: 'ADD_LOADING_FLAG',
		page,
	};
};

export const removePageFlags = (page) => {
	return {
		type: 'REMOVE_FLAGS',
		page,
	};
};

export const removeMultiplePages = (pages) => {
	return {
		type: 'REMOVE_MULTIPLE_PAGES',
		pages,
	};
};

export const updateComments = (updatedComment) => {
	return {
		type: 'UPDATE_COMMENT',
		updatedComment,
	};
};

export const updateFilterByName = (filterByName) => {
	return {
		type: 'UPDATE_FILTERED_NAME',
		filterByName,
	};
};

export const updateFilterByReference = (filterByReference) => {
	return {
	  type: 'UPDATE_FILTERED_REFERENCE',
	  filterByReference,
	};
  };

export const updateFilterByEnvelopeName = (filterByEnvelopeName) => {
	return {
		type: 'UPDATE_FILTERED_ENVELOPE_NAME',
		filterByEnvelopeName,
	};
};

export const updateTotalFilteredDocs = (totalFilteredDocs) => {
	return {
		type: 'UPDATE_TOTAL_FILTERED_DOCS',
		totalFilteredDocs,
	};
};
